var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasExtencion('consolidar_ventas_en_factura'))?_c('b-dropdown-item',{on:{"click":function($event){$event.preventDefault();return _vm.abrirConsolidar.apply(null, arguments)}}},[_c('i',{staticClass:"icon-list"}),_vm._v(" Consolidar para facturar ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }